<template>
    <div style="height: 100%">
        <el-tabs type="border-card" style="height: 100%;">
            <el-tab-pane label="维护企业隶属关系">
                <section class="container-wrapper">
                    <div class="container" style="padding: 0;border: none;">
                        <div class="content-left">
                                <el-tree
                                        ref="tree"
                                        @node-click="handleNodeClick"
                                        :key="1"
                                        :data="treeData"
                                        accordion
                                        :props="defaultProps"
                                        default-expand-all
                                        :expand-on-click-node="true"
                                        node-key="companyId"
                                        v-if="refreshTree"
                                >
                                </el-tree>
                        </div>
                        <div class="content-right" v-if="!subCompanyShow">
                            <div style="margin-top: 10px;margin-left: 10px">提示：若贵公司有子公司，且已在易派客平台完成注册，请维护隶属关系。</div>

                            <el-form :inline="true" :model="query" ref="query" style="text-align: center; margin-top: 200px">
                                <el-form-item  label="公司名称:" prop="companyName" >
                                    <el-input v-model="query.companyName" style="width: 300px"></el-input>
                                </el-form-item>
                                <el-button type="primary" icon="el-icon-search" @click="handleSubmit">提交</el-button>
                            </el-form>
                        </div>
                        <div class="content-right" v-else>
                            <TableList
                                    :loading="loading"
                                    :table-data="tableData"
                                    :table-label="tableLabel"
                                    :index-show="true"
                                    @handleSortChange="handleSortChange"
                                    @handleSelectionChange="handleSelectionChange"
                            >
                                <template v-slot:confirmInfo>
                                    已确认
                                </template>
                                <template v-slot:operation="slot">
                                    <el-button type="text" @click="dismissRelation(slot.scope.row)">解除隶属关系</el-button>
                                </template>
                            </TableList>
                        </div>
                    </div>
                </section>
            </el-tab-pane>
            <el-tab-pane label="确认企业隶属关系">
                <section class="container-wrapper">
                    <div class="container" style="padding: 0;border: none;">
                        <div class="content-left">
                            <el-tree
                                    ref="tree"
                                    @node-click="handleNodeClick"
                                    :key="1"
                                    :data="treeData"
                                    accordion
                                    :props="defaultProps"
                                    default-expand-all
                                    :expand-on-click-node="true"
                                    node-key="companyId"
                                    v-if="refreshTree"
                            >
                            </el-tree>
                        </div>
                        <div class="content-right">
                            <div style="margin: 10px">公司名称：{{currentCompany}}</div>
                            <TableList
                                    :loading="loading1"
                                    :table-data="tableData1"
                                    :table-label="tableLabel1"
                                    @handleSortChange="handleSortChange"
                                    @handleSelectionChange="handleSelectionChange"
                            >
                                <template v-slot:confirmInfo="slot">
                                    {{formStatus(slot.scope.row.status)}}
                                </template>
                                <template v-slot:operation="slot">
                                    <el-button type="text" v-if="slot.scope.row.status == 21" @click="handleConfirm(slot.scope.row)">确认</el-button>
                                </template>
                            </TableList>
                        </div>
                    </div>
                </section>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import TableList from '../../components/common/e-table-list'
    import Api from '../../api/insititution/index'
    export default {
        name: "maintenanceAffiliation",
        components: {
            TableList
        },
        props: {},
        data() {
            return {
                treeData:[],
                defaultProps: {
                    label: "companyName",
                    children:"childList"
                },
                query:{
                    companyName:''
                },
                subCompanyShow:false,
                loading:false,
                tableData:[],
                tableLabel: [
                    { label: '公司名称', param: 'sonCompanyName', align: 'center',width:'200'},
                    { label: '中石化编码', param: 'sonInternalCode', align: 'center'},
                    { label: '隶属关系确认情况', param: 'confirmInfo', align: 'center', slot:'confirmInfo' },
                    { label: '操作', align: 'center',slot:'operation' },
                ],
                refreshTree:true,
                loading1:false,
                tableData1:[],
                tableLabel1: [
                    { label: '母公司名称', param: 'parentCompanyName', align: 'center',width:'200'},
                    { label: '中石化编码', param: 'parentInternalCode', align: 'center'},
                    { label: '隶属关系确认情况', param: 'status', align: 'center', slot:'confirmInfo' },
                    { label: '操作', align: 'center',slot:'operation' },
                ],
                currentCompany:''
            }
        },
        computed: {},
        created() {
            this.getTreeList()
            this.getSubCompanyList()
            this.currentCompany = JSON.parse(localStorage.getItem('USERINFO')).companyName
        },
        methods: {
            handleNodeClick(node){
                this.tableData = []
                if(node.parentCompanyId == 0){
                    this.subCompanyShow = false
                }else {
                    let params = {
                        sonCompanyId:node.companyId,
                        parentCompanyId:node.parentCompanyId
                    }
                    Api.getOperationList(params)
                        .then((res) => {
                            if(res.code == '200'){
                                this.subCompanyShow = true
                                this.tableData.push(res.data[0])
                            }
                        })
                }

            },
            handleSubmit(){
                let params = {
                    sonCompanyName: this.query.companyName
                }
                if(!this.query.companyName){
                    this.$message({
                        type:"success",
                        message:'公司名称为空'
                    })
                    return;
                }
                Api.submitRelation(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                type:"success",
                                message:'企业隶属关系已维护，待子公司确认后方可生效。'
                            })
                            this.query.companyName = ''
                        }
                    })
            },
            handleSortChange(){

            },
            handleSelectionChange(){

            },
            getTreeList(){
                this.tableData.length = 0
                this.treeData.length = 0
                Api.getCompanyList()
                    .then((res) => {
                        if(res.code == '200'){
                            this.treeData.push(res.data)
                        }
                    })
            },
            dismissRelation(row){
                let params = {
                    sonCompanyId:row.sonCompanyId,
                    parentCompanyId:row.parentCompanyId
                }
                this.$confirm( '是否解除' + row.parentCompanyName +'与' + row.parentCompanyName + '的隶属关系',  '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    Api.releaseRelation(params)
                        .then((res) => {
                            if(res.code == '200'){
                                this.$message({
                                    type:'success',
                                    message:'解除隶属关系成功'
                                })
                                this.subCompanyShow = false
                                setTimeout(() => {
                                    //查询树的数据
                                    this.getTreeList();
                                    //<el-tree>组件使用v-if重新加载
                                    this.refreshTree = false
                                    this.$refs.tree.$nextTick(() => {
                                        this.refreshTree = true;
                                    })
                                }, 100);
                            }
                        })
                }).catch(() => {
                })

            },
            handleConfirm(val){
                this.$confirm('是否确认'+val.parentCompanyName +'是贵公司的母公司？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '拒绝',
                    type: 'warning',
                    distinguishCancelAndClose:true
                }).then(() => {
                    let params = {
                        operationId: val.operationId
                    }
                    Api.subCompanyConfirm(params)
                        .then((res) => {
                            if(res.code == '200'){
                                this.$message({
                                    type: 'success',
                                    message: '已确认!'
                                });
                                this.getSubCompanyList()
                                setTimeout(() => {
                                    //查询树的数据
                                    this.getTreeList();
                                    //<el-tree>组件使用v-if重新加载
                                    this.refreshTree = false
                                    this.$refs.tree.$nextTick(() => {
                                        this.refreshTree = true;
                                    })
                                }, 100);
                            }
                        })

                }).catch((action) => {
                   if(action == 'cancel'){
                       let params = {
                           operationId: val.operationId
                       }
                       Api.subCompanyRefuse(params)
                           .then((res) => {
                               if(res.code == '200'){
                                   this.$message({
                                       type: 'success',
                                       message: '已拒绝!'
                                   });
                                   this.getSubCompanyList()
                                   setTimeout(() => {
                                       //查询树的数据
                                       this.getTreeList();
                                       //<el-tree>组件使用v-if重新加载
                                       this.refreshTree = false
                                       this.$refs.tree.$nextTick(() => {
                                           this.refreshTree = true;
                                       })
                                   }, 100);
                               }
                           })

                   }
        });
            },
            formStatus(val){
                let res = ''
                switch (val) {
                    case 21: res='未确认';break;
                    case 30: res='已确认';break;
                    case 23: res='已拒绝';break;
                    case 31: res='母公司解除隶属关系';break;
                }
                return res
            },
            getSubCompanyList(){
                this.tableData1 = []
                Api.queryNeedReply()
                    .then((res) => {
                        if(res.code == '200'){
                            this.tableData1 = res.data
                        }
                    })
            }
        }

    }
</script>

<style lang="scss" scoped>
    .container-wrapper {
        height: 100%;
    }
    .container {
        height: 100%;
        display: flex;
        border-radius: 5px;
        .content-left {
        flex: 0 0 450px;
        height: 100%;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        padding: 10px;
        margin-right: 10px;
        /*overflow-y: auto;*/
            min-height: 500px;
            .content-title {
        width: 100%;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: rgb(242, 242, 242);
    }
            .content-btn {
        margin-top: 10px;
    }
    }
    .content-right {
        flex: 1;
        height: 100%;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        min-height: 500px;
        .content-title {
            width: 100%;
            height: 32px;
            line-height: 32px;
            background: rgb(242, 242, 242);
            padding: 0 10px;
        }
        .content-btn {
            margin-bottom: 10px;
        }
        }
    }
</style>
